import { render, staticRenderFns } from "./PrasymasIstorijaBusena.vue?vue&type=template&id=b5755cc2&scoped=true&"
import script from "./PrasymasIstorijaBusena.vue?vue&type=script&lang=js&"
export * from "./PrasymasIstorijaBusena.vue?vue&type=script&lang=js&"
import style0 from "./PrasymasIstorijaBusena.vue?vue&type=style&index=0&id=b5755cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5755cc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
